import { render, staticRenderFns } from "./SelectMembersChip.vue?vue&type=template&id=6756cf52"
import script from "./SelectMembersChip.vue?vue&type=script&lang=js"
export * from "./SelectMembersChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports